<template><main class="sso-page"><section><h1>统一账号登录</h1><p>正在前往统一认证，登录后返回当前应用。</p><el-button type="primary" @click="login">前往登录</el-button></section></main></template>
<script>
import {beginUnifiedLogin} from '../api/unifiedAuth';
export default {name:'SsoLogin', mounted(){this.login();}, methods:{login(){beginUnifiedLogin(this.$route.query.redirect);}}};
</script>
<style scoped>.sso-page{min-height:100vh;display:grid;place-items:center;background:#f6f7fb;color:#303133}.sso-page section{background:white;padding:40px;border-radius:12px;max-width:460px}.sso-page h1{font-size:24px}.sso-page p{line-height:1.8;color:#606266}</style>
